module.exports = __webpack_public_path__ + "img/ctrl-pauli-stub-mid-1.1e58c871.svg";